import React, { useEffect, useState } from "react";
import "./Orders.css";
import Container from "react-bootstrap/Container";
import { Row, Card, Col, Button, Form } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import * as MdIcons from "react-icons/md";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as BsIcons from "react-icons/bs";
import { AssignOrderInvestigator, OrderDetailsByID } from "../../apis/OrderAPI";
import { GetInvestigatorsName } from "../../apis/InvestigatorAPI";
import { GetCustomerAllReports } from "../../apis/ReportsAPI";
import dateFormat from "dateformat";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";

export default function AssignInvestigator() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderid = searchParams.get("orderid");
  const {user} = useSelector((state) => state.auth);

  const [orderData, setOrderData] = useState([]);
  const [investigatorList, setInvestigatorList] = useState([]);
  const [reportList, setReportList] = useState([]);
  const [orderInstruction, setOrderInstruction] = useState("");
  const [selectedReport, setSelectedReport] = useState([]);

  const defaultInvestigator = {
    id: "0",
    investigatorName: "Choose Investigator....",
  };
  const [investigator, setInvestigator] = useState(defaultInvestigator);

  const defaultReport = {
    mapping_id: "0",
    report_id: "0",
    report_name: "Choose Report....",
    report_price: "0",
    is_primary: false,
  };

  const [report, setReport] = useState([defaultReport]);

  async function GetOrderData() {
    var result = await OrderDetailsByID(orderid, "edit");
    var data = result.data;
    var selectedreport = data.item3;
    setOrderData(data.item1);
    if (selectedreport.length > 0) {
      setSelectedReport({
        mapping_id: selectedreport[0].order_report_mapping_id + "",
        report_id: selectedreport[0].report_id_ref + "",
        report_name: selectedreport[0].report_name,
        report_price: selectedreport[0].reportprice + "",
        is_primary: true,
      });
    }
  }

  async function GetInvestigators() {
    var result = await GetInvestigatorsName();
    var data = result.data;
    setInvestigatorList(data);
  }

  async function GetCustomerReports() {
    var result = await GetCustomerAllReports(orderData.customer_id);
    var data = result.data;
    let filterReport = data.filter(
      (x) => x.report_id == selectedReport.report_id
    );
    if (filterReport.length > 0) setReport(filterReport);
    setReportList(data);
  }

  useEffect(() => {
    GetOrderData();
    GetInvestigators();
  }, []);

  useEffect(() => {
    if (orderData.customer_id != undefined) GetCustomerReports();
  }, [orderData.customer_id]);

  const handleAssign = async () => {
    if (investigator.id !== "0" && report[0].report_id !== "0") {
      var data = {
        id: orderid,
        totalRows: 0,
        orderApplicantName: "",
        orderCoApplicant: "",
        orderCustomerName: "",
        orderCustomerIdRef: orderData.customer_id,
        orderUserIdRef: user.userid,
        orderRequestorIdRef: 0,
        orderAddress: "",
        orderNotes: "",
        orderStartDate: "",
        orderEndDate: "",
        orderPo: "",
        orderInvestigatorId: investigator.id,
        investigatorName: "",
        orderStatusId: 0,
        orderStatusName: "",
        orderPrelimReportDate: "",
        orderTimestamp: "",
        miscPrice: 0,
        userName: "",
        requestorName: "",
        reportId: 0,
        reportsName: "",
        reports: JSON.stringify(report),
        adminInstruction: orderInstruction,
        customerInstruction: "",
        billingInformation: "",
        applicantFormId: 0,
        attachments: [],
      };
      //console.log(data);
      var result = await AssignOrderInvestigator(data);
      if (result.status === 200) {
        alert.success("Investigator assigned",{
          onClose: () => {
            navigate("/Admin/OrderDetail?id=" + orderid);
          }
        });

      } else alert.error("Unable to assign investigator");
      GetOrderData();
    } else {
      if (investigator.id === "0") alert.error("Please choose an investigator");
      if (report[0].report_id === "0") alert.error("Please choose a report");
    }
  };

  let handleReport = (i, e) => {
    let newReport = [...report];
    let primary = false;
    if (i == 0) {
      primary = true;
    }
    let newValue = {
      mapping_id: "0",
      report_id: e.report_id,
      report_name: e.report_name,
      report_price: e.report_price,
      is_primary: primary,
    };
    newReport[i] = newValue;
    setReport(newReport);
  };

  const handlePrice = (i, e) => {
    let newReport = [...report];
    newReport[i].report_price = e.target.value;
    setReport(newReport);
  };

  let addReport = () => {
    setReport([...report, defaultReport]);
  };

  let removeReport = (i) => {
    let newReport = [...report];
    newReport.splice(i, 1);
    setReport(newReport);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="mt-5">
                  <Col lg={12} xs={12}>
                    <Card className="notifications-card">
                      <div className="card-head order-head">
                        <div className="card-title h5">
                          Assign Order to Investigator{" "}
                        </div>
                        <Link
                          to={"/Admin/OrdersDetail?id=" + orderid}
                          className="back-btn"
                        >
                          <BsIcons.BsArrowLeft />
                        </Link>
                      </div>
                      <div className="assign-order-detail-box">
                        <Row>
                          <Col lg={6} md={12}>
                            <div className="cards-text">
                              <div className="cards-list-group">
                                <div className="cards-list-item">
                                  <span>Order No:</span> {orderData.order_id}
                                </div>
                                <div className="cards-list-item">
                                  <span>Order Date:</span>{" "}
                                  {dateFormat(
                                    orderData.order_start_date,
                                    "mm/dd/yyyy"
                                  )}
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="cards-text">
                              <div className="cards-list-group">
                                <div className="cards-list-item">
                                  <span>Customer Name:</span>{" "}
                                  {orderData.customer_first_name}{" "}
                                  {orderData.customer_last_name}
                                </div>
                                <div className="cards-list-item">
                                  <span>Requestor:</span>{" "}
                                  {orderData.requestor_first_name}{" "}
                                  {orderData.requestor_last_name}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={12}>
                            <div className="cards-text">
                              <div className="cards-list-group">
                                <div className="cards-list-item">
                                  <Row>
                                    <Col lg={4} md={12}>
                                      <Form.Label>Investigator:</Form.Label>
                                    </Col>
                                    <Col lg={8} md={12}>
                                      <DropDownList
                                        className="form-control custom-form-control-select"
                                        data={investigatorList}
                                        textField="investigatorName"
                                        dataItemKey="id"
                                        defaultItem={defaultInvestigator}
                                        value={investigator}
                                        onChange={(e) =>
                                          setInvestigator(e.target.value)
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {report.map((element, index) => (
                          <Row key={index}>
                            <Col lg={6} md={12}>
                              <div className="cards-text">
                                <div className="cards-list-group">
                                  <div className="cards-list-item">
                                    <Row>
                                      <Col lg={4} md={12}>
                                        <Form.Label>
                                          {" "}
                                          {index == 0
                                            ? "Report Type"
                                            : "Other Type"}
                                          :
                                        </Form.Label>
                                      </Col>
                                      <Col lg={8} md={12}>
                                        <DropDownList
                                          className="form-control custom-form-control-select"
                                          data={reportList}
                                          textField="report_name"
                                          dataItemKey="report_id"
                                          defaultItem={defaultReport}
                                          value={report[index]}
                                          onChange={(e) =>
                                            handleReport(index, e.target.value)
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col lg={6} md={12}>
                              <Form.Group controlId="formBasicText">
                                <Row>
                                  <Col lg={3} md={12}>
                                    <Form.Label>Report Price:</Form.Label>
                                  </Col>
                                  <Col lg={8} md={12}>
                                    <Form.Control
                                      type="number"
                                      value={report[index].report_price}
                                      required
                                      onChange={(e) => handlePrice(index, e)}
                                    />
                                  </Col>
                                  <Col lg={1} md={12}>
                                    <div className="assign-delt">
                                      {index ? (
                                        <Link
                                          type="button"
                                          className="button remove"
                                          onClick={() => removeReport(index)}
                                        >
                                          <MdIcons.MdDeleteForever />
                                        </Link>
                                      ) : null}
                                    </div>
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Col>
                          </Row>
                        ))}
                        <Row>
                          <div className="add-report-btn mb-3">
                            <Link
                              to={
                                "/Admin/AssignInvestigator?orderid=" + orderid
                              }
                              onClick={() => addReport()}
                            >
                              Add Report
                            </Link>
                          </div>
                        </Row>
                        <Row>
                        <Col lg={6} md={12}>
                          <Form.Group
                            className="mb-5"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={3} md={12}>
                                <Form.Label>Other Instructions:</Form.Label>
                              </Col>
                              <Col lg={9} md={12}>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  value={orderInstruction}
                                  onChange={(e) =>
                                    setOrderInstruction(e.target.value)
                                  }
                                />
                              </Col>
                            </Row>
                          </Form.Group>
                          </Col>
                          <Col lg={6} md={12}></Col>
                          <div class="ordbtn row">
                            <div class="btorng col-lg-6 col-md-12 text-right">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAssign}
                              >
                                Assign
                              </button>
                            </div>
                            <div class="btgry col-lg-6 col-md-12 text-left">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                  navigate("/Admin/OrderDetail?id=" + orderid);
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                          
                        </Row>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
